import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/security/authentication.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
    standalone: false
})
export class LogoutComponent implements OnInit {

    constructor(private router: Router, private authService: AuthenticationService) { }

    ngOnInit() {
    }

    goBack() {
        this.router.navigate(['/home']);
    }

}
